"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _menu = require("../menu");

var _messages = require("../../../constants/messages");

var _routes = require("../../../constants/routes");

var MutualInboxMenu = function MutualInboxMenu(_ref) {
  var activeListItem = _ref.activeListItem,
      activeHoverListItem = _ref.activeHoverListItem,
      altCount = _ref.altCount,
      count = _ref.count,
      customLinkRenderer = _ref.customLinkRenderer,
      onItemMouseEnter = _ref.onItemMouseEnter,
      onItemMouseLeave = _ref.onItemMouseLeave;
  var isActive = _.NAV_MENUS.MUTUAL_INBOX === activeListItem; // any count regardless of alt count -> show count
  // no count and any alt count -> show indicator
  // no count and no alt count -> nothing

  var showIndicatorDot = !count && !!altCount;
  return _react.default.createElement(_menu.MenuItem, {
    activeHoverListItem: activeHoverListItem,
    altCountBadge: false,
    count: count,
    customLinkRenderer: customLinkRenderer,
    icon: "message",
    id: _.NAV_MENUS.MUTUAL_INBOX,
    isSelected: isActive,
    label: _messages.MESSAGE_ID.MUTUAL_INBOX_MENU,
    onMouseEnter: onItemMouseEnter,
    onMouseLeave: onItemMouseLeave,
    route: _routes.ROUTE.MUTUAL_INBOX,
    showIndicatorDot: showIndicatorDot,
    subMenuUI: null
  });
};

var _default = MutualInboxMenu;
exports.default = _default;